import React, { useEffect, useState } from "react";
import { Col, Modal, Row } from "react-bootstrap";
import { Button, Loading } from "@atoms";
import { h5, h7, body1, body2 } from '@typo/typo.module.css';
import { textPrimary, textSecondary } from '@typo/color.module.css';

import { useLazyQuery, useMutation, useQuery } from "@apollo/react-hooks";
import { useAlert } from "react-alert";
import { customerUpdate } from "@components/pages/ContactPage/__generated__/customerUpdate";
import { CUSTOMER_UPDATE } from "@components/pages/ContactPage/queries";
import { joinErrorMessages } from "@utils";
import { useOtp } from "@src/hooks/useOtp";
import { MaccaronTextField } from "@molecules/MaccaronTextField";
import { useFormik } from "formik";
import { verifyOtp } from "@src/hooks/useOtp/__generated__/verifyOtp";
import {
  vouchers_availableVouchers,
  vouchers_availableVouchers_edges_node
} from "@molecules/MyVoucherModal/__generated__/vouchers";
import { MY_VOUCHER } from "@molecules/MyVoucherModal/queries";
import { Voucher } from "@atoms/Voucher";

export interface IProps {
  show: boolean;
  onHide: any;
  closeNotifyMe: any;
  forceCheckout: any;
  vouchers: vouchers_availableVouchers_edges_node[];
  selectVoucher: (code: string) => void;
}


const MyVoucherModal: React.FC<IProps> = (
  {
    show, onHide, forceCheckout, vouchers, selectVoucher
  }: IProps) => {
  const alert = useAlert();
  const [selectedVoucher, setSelectedVoucher] = useState('');

  const formik = useFormik({
    initialValues: {
      mobileNumber: "",
      otp: "",
    },
    onSubmit: (values) => {

    },
  });

  const handleSelectVoucher = (value) => {
    setSelectedVoucher(value);
  }

  const handleSelectClick = () => {
    selectVoucher(selectedVoucher);
  }

  return (
    <div>
      <Modal show={show} onHide={onHide} scrollable={true}>
        <Modal.Header closeButton>
          <label className={h5}>My Vouchers</label>
        </Modal.Header>
        <Modal.Body style={{ textAlign: "center", margin: "0" }}>
          {
            vouchers && (
              vouchers.map((item) => {
                return <Voucher key={item.id} item={item} onClickVoucher={handleSelectVoucher} showProduct={false} isSelected={selectedVoucher === item.code} />;
              })
            ) || <Loading />
          }
        </Modal.Body>
        <Modal.Footer style={{ margin: "1rem 0" }}>
          <Row style={{ width: "100%" }}>
            <Col>
              <Button style={{ width: "100%", marginTop: "1rem" }} onClick={handleSelectClick} disabled={selectedVoucher === ''}>Select</Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>
    </div>
  )
};

export { MyVoucherModal }